import { Link, useNavigate, useLocation } from 'react-router-dom';
import ROLES from './rolesData';
import LandingLogo from './LandingLogo';

const PLATFORM_LINKS = [
  { id: 'lp-home', label: 'Home' },
  { id: 'lp-features', label: 'Features' },
  { id: 'lp-services', label: 'Services' },
  { id: 'lp-how-it-works', label: 'How It Works' },
  { id: 'lp-about', label: 'About' },
  { to: '/logistics', label: 'Logistics' },
  { id: 'lp-contact', label: 'Contact' },
];

export default function LandingFooter() {
  const navigate = useNavigate();
  const location = useLocation();

  function scrollToSection(id) {
    if (location.pathname !== '/') {
      navigate('/', { state: { scrollTo: id } });
      return;
    }
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  return (
    <footer className="lp-footer">
      <div className="lp-container">
        <div className="lp-footer-grid">
          <div className="lp-footer-brand">
            <LandingLogo variant="footer" />
            <p>School Certificate Management Platform — digital certificate generation and document management for schools, distributors and administrators.</p>
          </div>

          <div>
            <h4>Platform</h4>
            <ul>
              {PLATFORM_LINKS.map((l) => (
                <li key={l.to || l.id}>
                  {l.to ? <Link to={l.to}>{l.label}</Link> : <button onClick={() => scrollToSection(l.id)}>{l.label}</button>}
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4>Access</h4>
            <ul>
              {ROLES.map((role) => (
                <li key={role.key}><Link to={role.path}>{role.label}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4>Support</h4>
            <ul>
              <li><button onClick={() => scrollToSection('lp-contact')}>Contact</button></li>
              <li><a href="mailto:info@smartindiasolution.com">Help</a></li>
            </ul>
          </div>

          <div>
            <h4>Contact Us</h4>
            <ul>
              <li><a href="mailto:info@smartindiasolution.com"><i className="fa-solid fa-envelope" style={{ marginRight: 8, opacity: 0.7 }}></i>info@smartindiasolution.com</a></li>
              <li><button onClick={() => scrollToSection('lp-contact')}>Send us a message</button></li>
            </ul>
          </div>
        </div>

        <div className="lp-footer-bottom">
          © {new Date().getFullYear()} One Click School Solutions. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
